const types = {
  EXIBIR_DIALOG_INTERESSADO: 'EXIBIR_DIALOG_INTERESSADO',
  ESCONDER_DIALOG_INTERESSADO: 'ESCONDER_DIALOG_INTERESSADO',
  EXIBIR_DIALOG_ASSUNTO: 'EXIBIR_DIALOG_ASSUNTO',
  ESCONDER_DIALOG_ASSUNTO: 'ESCONDER_DIALOG_ASSUNTO',
  EXIBIR_DIALOG_GLOSSARIO: 'EXIBIR_DIALOG_GLOSSARIO',
  ESCONDER_DIALOG_GLOSSARIO: 'ESCONDER_DIALOG_GLOSSARIO',

  SET_LISTA_TIPO_DOCUMENTO: 'SET_LISTA_TIPO_DOCUMENTO',
  SET_LISTA_UNIDADE_PROCEDENCIA: 'SET_LISTA_UNIDADE_PROCEDENCIA',
  SET_LISTA_TIPO_INTERESSADO: 'SET_LISTA_TIPO_INTERESSADO',
  SET_LISTA_INTERESSADOS: 'SET_LISTA_INTERESSADOS',
  SET_LISTA_ASSUNTO: 'SET_LISTA_ASSUNTO',
  SET_LISTA_ASSUNTO_NIVEL_1: 'SET_LISTA_ASSUNTO_NIVEL_1',
  SET_LISTA_ITENS_GLOSSARIO: 'SET_LISTA_ITENS_GLOSSARIO',

  SET_TIPO_DOCUMENTO: 'SET_TIPO_DOCUMENTO',
  SET_UNIDADE_PROCEDENCIA: 'SET_UNIDADE_PROCEDENCIA',
  SET_TIPO_INTERESSADO: 'SET_TIPO_INTERESSADO',
  SET_INTERESSADO: 'SET_INTERESSADO',
  SET_ASSUNTO: 'SET_ASSUNTO',
  SET_RESUMO_ASSUNTO: 'SET_RESUMO_ASSUNTO',
  SET_URGENTE: 'SET_URGENTE',
  SET_MOTIVO_URGENCIA: 'SET_MOTIVO_URGENCIA',
  SET_DOCUMENTO_ORIGEM: 'SET_DOCUMENTO_ORIGEM',
  SET_EMITENTE: 'SET_EMITENTE',
  SET_DATA_DOCUMENTO_ORIGEM: 'SET_DATA_DOCUMENTO_ORIGEM',
  SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM: 'SET_DATA_RECEBIMENTO_DOCUMENTO_ORIGEM',
  SET_OBSERVACAO: 'SET_OBSERVACAO',

  SET_DOCUMENTO: 'SET_DOCUMENTO',
  SET_BUSCANDO_DOCUMENTO_ORIGEM: 'SET_BUSCANDO_DOCUMENTO_ORIGEM',

  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR',
  SHOW_CONFIRMATION_DIALOG: 'ui/SHOW_CONFIRMATION_DIALOG',
  HIDE_CONFIRMATION_DIALOG: 'ui/HIDE_CONFIRMATION_DIALOG'
}

export default types



// WEBPACK FOOTER //
// ./src/vuex/autuacao/mutations-types.js